const getIdFromObject = (obj) => {
  if (!obj || !obj?.id || obj?.id === 0) return null

  return obj?.id
}

export default getIdFromObject
